import {map, merge} from "lodash";
import React, { Component} from 'react';

// temporary
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import {DebugElement} from "../Atollon/debug";
import Checkbox from "react-md/lib/SelectionControls/Checkbox";
import { FontIcon } from "react-md";

export const InfoBox = ({children}) => {

    // <div class="flex-col">
    return (
        <Card  className="margin-bottom">
            <CardText>
                {children}
            </CardText>
        </Card>
    )
};
export const InfoBox_TextField = ({name, value}) => {
    return (
        <div className="flex-row">
            <p className="request-label">{name}</p>
            <p>{value}</p>
        </div>
    );
};
export const InfoBox_Field = ({name, value}) => {
    return (
        <div className="flex-row">
            <p className="request-label">{name}</p>
            <div>{value}</div>
        </div>
    );
};

/**
 *
 * Simple case
 *
 * @param headerAsList ... ["head1","head2"]
 * @param elementsAsList ... [["row11","cell12"],["cell21","cell22"]]
 * @returns {*}
 * @constructor
 *
 * HEADER OPTIONS
 *
 *  - { wrap { style: ReactCSSStyle }}
 *
 * EXAMPLES:
 *
 *  headerAsList={["Jméno", "Identifikátor", "Akce" ]}
 *
 *  headerAsList={["Jméno", "Identifikátor", {text: "Akce", wrap:{ style: { textAlign: 'right', width: '100%' }}}]}
 *
 */

export const TouchTable_alignColumnRight = ( text ) =>
{
    return { text , wrap:{ style: { textAlign: 'right', width: '100%' }}};
};

let touch_table_unique_key = 0;
export const TouchTable = ({headerAsList, elementsAsList}) =>
{
    return (
        <div className="">
            <div className="table">
                {

                    headerAsList && (
                        <div className="table-row header">
                            {map(headerAsList, (item, index)=>{

                                const text = item.text ? item.text : item;
                                return (
                                    <div key={index} className="table-col">{text}</div>
                                )
                            })}
                        </div>
                    )
                }
                {
                    map(elementsAsList, (itemOfList, rowIndex)=> {
                        return (
                            <div className="table-row" key={rowIndex}>
                                {
                                    map(itemOfList, (item, index) => {

                                        let wrap = ( columnIndex, element ) =>
                                        {

                                            if( headerAsList[ columnIndex ] )
                                            {
                                                if( headerAsList[ columnIndex ].wrap )
                                                {
                                                    let wrapStyle = headerAsList[ columnIndex ].wrap.style;
                                                    let style = {};
                                                    if( wrapStyle )
                                                    {
                                                        style = wrapStyle;
                                                    }
                                                    // console.log( {index, wrapStyle, element} );
                                                    return (<div style={style} className={"__wrapper"}>{element}</div>);
                                                }
                                            }

                                            return element;
                                        };

                                        return (
                                            <div key={rowIndex+index} className="table-col">{wrap( index, item )}</div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export const TouchAvatar = ({image, text, subtext, onClick}) => {

    // md-text md-fake-btn md-pointer--hover md-list-tile--active
    return (
        <div className={"md-fake-btn--no-outline md-list-tile md-list-tile--two-lines"} style={{paddingLeft:0}} onClick={onClick}>
            <div className="md-tile-addon md-tile-addon--avatar">
                <div className="md-inline-block md-avatar md-avatar--black">
                    <div className="md-avatar-content"><i className="md-icon material-icons">person</i></div>
                </div>
            </div>
            <div className="md-tile-content md-tile-content--left-avatar">
                <div className="md-tile-text--primary md-text" >{text}</div>
                <div className="md-tile-text--secondary md-text--secondary">{subtext}</div>
            </div>
        </div>
    );
};

export const TouchPageHeader = ({title, subtitle, buttons, debugText, children}) => {


    // className="flex-row flex-space-between margin-header" ... OrganizationPackageMappingHeaderAsReact
    // className="flex-row flex-space-between margin-header" ... components/organization/header.js

    let background = '#F5F5F5';

    return (
        <div style={{position:'relative', background}}>
            <div style={{
                right: '-45000px',
                position: 'absolute',
                bottom: '0',
                width: '99999px',
                //background: '#ff0000',
                background,
                height: '9999px',
                zIndex:1,
                borderBottom: '1px solid #E0E0E0'
            }} />
            <div style={{height:'40px'}} />
            {debugText? <DebugElement text={debugText}/> : null}
            <div className="flex-row flex-space-between margin-header"
                 style={{
                     position: 'relative',
                     zIndex: 2,
                     margin: 0,
                     background,
                     border:0 // disable
                 }}
            >
                <h3 className="title" style={{fontSize: '30px', fontWeight: 'normal'}}>{title}</h3>
                {buttons}
            </div>
            {/* children */}
            <div style={{height:'40px'}} />
        </div>
        )

};

// to gather if there is one or more spacing sizes ...
export const TouchPageHeader_and_content_spaceBetween = ({heightPx}) => {

    if( ! (""+heightPx).match(/px/))
    {
        heightPx = heightPx + "px";
    }

    return (<div style={{height:heightPx}} />)
};

// const Header = ({ className, title, links, history, primaryButtons, buttons }) => {
//     return (
//         <div className={`flex-col margin-header ${className}`}>
//             {title && <h3 className="title">{title}</h3>}
//             {(primaryButtons || buttons) &&
//             <Buttons
//                 history={history}
//                 primary={primaryButtons}
//                 buttons={buttons}
//             />}
//         </div>
//     );
// };

export const TouchCheckbox = ( propsDictionary ) =>
{
    const newClassName = ( propsDictionary.className || "" ) + " touchCheckbox ";
    let props = merge( {className: newClassName }, propsDictionary);
    // console.log( {propsDictionary, props, newClassName});
    return ( <Checkbox {...props} /> );
};

export const TouchTableHeader = ( propsAsDictionary ) =>
{
    let { title, titleNumber, titleButtons } = propsAsDictionary;
    return (
        <div className="TouchTableHeader">
            <div className="TouchTableHeader-spacing">
                <div style={{ padding: '8px 0 0 0', display: 'inline-block' }}>
                    <div className="TouchTableHeader-title">{title}</div>
                    {typeof( titleNumber ) !== 'undefined' ?
                        <TouchNumber text={titleNumber || 0} />
                        : null
                    }
                </div>
                {titleButtons ?
                    <div style={{ float: 'right', margin: '0 0 0 0' }}>
                        {titleButtons}
                    </div>
                    : null
                }
                {titleButtons ?
                    <div style={{ clear: 'both' }} />
                    : null
                }
            </div>
        </div>
    );
};

export const TouchNumber = ( propsAsDictionary ) =>
{
    const className = propsAsDictionary.className || "";
    return (<div className={`touchNumber ${className}`} style={propsAsDictionary.style}>{propsAsDictionary.text}</div>);
};

export const TouchVerticalValue = ( propsAsDictionary ) =>
{
    let { title, value, onClick, icon, valueColor } = propsAsDictionary;

    let style = {};
    if( onClick ){  style.cursor = 'pointer'; }

    let valueStyle = {};
    if( valueColor ){ valueStyle.color = valueColor; }

    return (
        <div className="TouchVerticalValue" onClick={onClick} style={style}>
            <div className="TouchVerticalValue-title">{
                icon ?
                    (<div>
                        <FontIcon className="touchIcon-highligted_onTheLeftSide">{icon}</FontIcon>
                        <span style={{ verticalAlign: 'middle' }}>{title}</span>
                    </div>)
                : title
            }</div>
            <div className="TouchVerticalValue-value" style={valueStyle}>{value}</div>
        </div>
    );
};

export const TouchVerticalValue_2 = ( propsAsDictionary ) =>
{
    let { title, value, onClick } = propsAsDictionary;

    return (
        <div className="TouchVerticalValue_2" onClick={onClick} style={ onClick? {cursor: 'pointer'} : null }>
            <div className="TouchVerticalValue_2-title">{title}</div>
            <div className="TouchVerticalValue_2-value">{value}</div>
        </div>
    );
};


export const TouchVerticalValueRow = ( propsAsDictionary ) =>
{
    let { children } = propsAsDictionary;

    return (
        <div className="TouchVerticalValueRow">
            {children}
        </div>
    );
};

export const TouchGreyBackgroundWithBorder = ({children}) =>
{
    return (
        <div className={"TouchGreyBackgroundWithBorder"}>
            {children}
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/AtollonTheme/ReactElements.js